import { configureStore } from "@reduxjs/toolkit"

import { authSlice } from "../features/Auth/Slice"
import { GroupSlice } from "../features/Groups"
import { reportsSlice } from "../features/Insights"
import { MembersSlice } from "../features/Members"
import { ModelSlice } from "../features/Models/Slice"
import { PermissionsSlice, RoleSlice } from "../features/Roles"
import { WorkflowSlice } from "../features/Workflows"
import { ProjectSlice } from "../features/projects"

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    permissions: PermissionsSlice.reducer,
    members: MembersSlice.reducer,
    roles: RoleSlice.reducer,
    groups: GroupSlice.reducer,
    project: ProjectSlice.reducer,
    workflow: WorkflowSlice.reducer,
    reports: reportsSlice.reducer,
    models: ModelSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ thunk: true }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
